export const getGUIDAndExtentionFromFileURL = ({ fileURL }) => {

    const splitFileURL = fileURL.split("/")

    const fileGUIDWithExtension = splitFileURL.at(-1)

    const fileGUIDWithExtensionSplit = fileGUIDWithExtension.split('.')

    const fileGUID = fileGUIDWithExtensionSplit[0]
    const fileExtension = fileGUIDWithExtensionSplit[1]

    return {
        fileGUID,
        fileExtension
    }
}